import React, { useEffect, useState } from 'react'
import Chart from 'react-apexcharts'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { Card, CardBody, Button, CardHeader,  UncontrolledButtonDropdown, DropdownMenu,  DropdownToggle, ButtonGroup, DropdownItem} from 'reactstrap'
import classnames from "classnames";
import { getActivityReplyGraphs } from '../../../../../actions/activities_actions'
import { getSurveyWordCloud } from '../../../../../actions/activities_reply_actions';
import Loader from "react-loaders";
import LoadingOverlay from 'react-loading-overlay-ts';
import ReactWordcloud from "react-wordcloud";
import { Resizable } from "re-resizable";
import GraphCartsWordCloud from './GraphCartsWordCloud';
import {
    faBars,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const Graphcharts = () => {


    const dispatch = useDispatch()
    const params = useParams()

    const [isLoading, setLoading] = useState(true)
    const [surveyResponse, setSurveyResponse] = useState([])
   
    const [newDemographicsActiveTab, setNewDemographicsActiveTab] = useState('City')
const [totalReplies, set_totalReplies] = useState('')
    const [newCityStats, setNewCityStats] = useState({
        options: {},
        series: [],
        labels: []
    })
   
    const [newGenderStats, setNewGenderStats] = useState({
        options: {},
        series: [],
        labels: []
    })
    const [newIncomeRangeStats, setNewIncomeRangeStats] = useState({
        options: {},
        series: [],
        labels: []
    })
    const [newAgeRangeStats, setNewAgeRangeStats] = useState({
        options: {},
        series: [],
        labels: []
    })
   



    const activityGraphs = () => {

        dispatch(getActivityReplyGraphs({ activityId: params.activityid }))
            .then((response) => {

              
                set_totalReplies(response.payload.content.totalReplies)
              
                let newCityCount=[]
                let newCityName=[]
                response.payload.content.demographics.newRepliesCities.length >0 && response.payload.content.demographics.newRepliesCities.map(city =>{
                    newCityCount.push(city.count)
                    newCityName.push(city._id)
                })
                let newGenderCount=[]
                let newGenderName=[]
                response.payload.content.demographics.newRepliesGenders.length >0 && response.payload.content.demographics.newRepliesGenders.map(gender =>{
                    newGenderCount.push(gender.count)
                    newGenderName.push(gender._id)
                })
                let newIncomeCount=[]
                let newIncomeName=[]
                response.payload.content.demographics.newRepliesIncomes.length >0 && response.payload.content.demographics.newRepliesIncomes.map(income =>{
                    newIncomeCount.push(income.count)
                    newIncomeName.push(income._id)
                })
                let newAgeCount=[]
                let newAgeName=[]
                response.payload.content.demographics.newRepliesAges.length >0 && response.payload.content.demographics.newRepliesAges.map(age =>{
                    newAgeCount.push(age.count)
                    newAgeName.push(age._id)
                })
               
                

               
                setNewCityStats({
                    options: {
                        labels: newCityName,
                        dataLabels: {
                            enabled: true
                        },
                        legend: {
                            position: 'left'
                        },
                        //colors: colors

                    },
                    series: newCityCount,
                })
                setNewGenderStats({
                    options: {
                        labels: newGenderName,
                        dataLabels: {
                            enabled: true
                        },
                        legend: {
                            position: 'left'
                        },
                        //colors: colors

                    },
                    series: newGenderCount,
                })
                setNewIncomeRangeStats({
                    options: {
                        labels: newIncomeName,
                        dataLabels: {
                            enabled: true
                        },
                        legend: {
                            position: 'left'
                        },
                        //colors: colors

                    },
                    series: newIncomeCount,
                })
                setNewAgeRangeStats({
                    options: {
                        labels: newAgeName,
                        dataLabels: {
                            enabled: true
                        },
                        legend: {
                            position: 'left'
                        },
                        //colors: colors

                    },
                    series: newAgeCount,
                })


                setSurveyResponse([...response.payload.content.surveyGraphs])
                setLoading(false)
            })
            .catch(err => {
                setLoading(false)
            })
    }

    useEffect(() => {
        activityGraphs()
    }, [])

    // word cloud options

    // Setting graph options based on different question types
    // const getRadioCheckboxGraphs = (response) => {


    //     let series = []
    //     let label = []
    //     response.availableOptions.length > 0 && response.availableOptions.map(option => {
    //         series.push(option.count)
    //          label.push(option.text)
    //     })

    //     return {
    //         options: {
    //             chart: {
    //                 id: 'apexchart-example-2'
    //             },
    //             labels: label,
    //         },
    //         series: series,
    //     }

    // }


    // const getRadioCheckboxGraphs = (response) => {
    //     let series = [];
    //     let labels = [];
    //     let maxLength = 50
    //     response.availableOptions.length > 0 &&
    //         response.availableOptions.forEach((option) => {
    //             series.push(option.count);
    //             let label = option.text;
    //             label = label.length > 30 ? '' : label;
    //             labels.push(label);
    //             // let splitIndex = label.lastIndexOf(' ', maxLength);

    //             // //     // If no space found within the first maxLength characters, split at maxLength
    //             //      if (splitIndex === -1) {
    //             //          splitIndex = maxLength;
    //             //      }

    //             // //     // Extract the portion of the label for the current line
    //             //      const line = label.substring(0, splitIndex);
    //             //      labels.push(line)

    //         });



    //     return {
    //         options: {
    //             chart: {
    //                 id: 'apexchart-example-2'
    //             },
    //             labels: labels
    //         },
    //         series: series
    //     };
    // };

    const getRadioCheckboxGraphs = (response) => {
        let series = [];
        let labels = [];
        response.availableOptions.length > 0 &&
            response.availableOptions.forEach((option) => {
                series.push(option.count);
                let label = option.text;
                // Trim label to 10 characters if it exceeds that length
                // label = label.length > 40 ? '' : label;
                labels.push(label);
            });

        return {
            options: {
                chart: {
                    id: 'apexchart-example-2'
                },
                legend: {
                    // show: false 
                    position: 'bottom'
                },
                labels: labels

            },
            series: series
        };
    };

    const newToggle = (tab) => {
        if (newDemographicsActiveTab !== tab) {
            setNewDemographicsActiveTab(tab)
        }
    }

    const newDemographicsChart = () => {
        console.log('demographics active tab ->', newDemographicsActiveTab)
        if (newDemographicsActiveTab === 'City') {
            return (
                <Card style={{ boxShadow: 'none', border: '0' }}>
                    <CardBody className="p-0">
                        <div className="pie">

                            <Chart options={newCityStats.options} series={newCityStats.series} type="pie" height="400" />
                        </div>
                    </CardBody>
                </Card>
            )
        } else if (newDemographicsActiveTab === 'Gender') {
            return (
                <Card style={{ boxShadow: 'none', border: '0' }}>
                    <CardBody className="p-0">
                        <div id="donut">
                            <Chart options={newGenderStats.options} series={newGenderStats.series} type="donut" height="200" />
                        </div>
                    </CardBody>
                </Card>

            )
        }
        else if (newDemographicsActiveTab === 'Income Range') {
            return (
                <Card style={{ boxShadow: 'none', border: '0' }}>
                    <CardBody className="p-0">
                        <div id="pie">
                            <Chart options={newIncomeRangeStats.options} series={newIncomeRangeStats.series} type="pie" height="400" />
                        </div>
                    </CardBody>
                </Card>

            )
        }
        if (newDemographicsActiveTab === 'Age Range') {
            return (
                <Card style={{ boxShadow: 'none', border: '0' }}>
                    <CardBody className="p-0">
                        <div className="pie">

                            <Chart options={newAgeRangeStats.options} series={newAgeRangeStats.series} type="donut" height="300" />
                        </div>
                    </CardBody>
                </Card>
            )
        }

      
    }

    const getImageVideoGraph = (response) => {
        return {
            options: {
                labels: ['Responses'],
                plotOptions: {
                    radialBar: {
                        hollow: {
                            size: '70%',
                        }
                    },
                },
            },
            series: [response.count],
        }
    }

    const getLongTextGraph = (response) => {
        return {
            series: [
                {
                    name: 'Responses',
                    data: [response.longResponse.count, response.shortResponse.count]
                }
            ],
            options: {
                chart: {
                    id: 'apexchart-example-3',
                    toolbar: {
                        show: false
                    }
                },
                dataLabels: {
                    enabled: false
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '55%',
                        endingShape: 'rounded'
                    },
                },
                width: "20",
                xaxis: {
                    categories: ['Long Responses', 'Short Responses']
                },
            }
        }
    }

    const getImageVideoTextGraph = (response) => {
        return {
            series: [
                {
                    name: 'Responses',
                    data: [response.fileResponse.count, response.textResponse.count]
                }
            ],
            options: {
                chart: {
                    id: 'apexchart-example-3',
                    toolbar: {
                        show: false
                    }
                },
                dataLabels: {
                    enabled: false
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '55%',
                        endingShape: 'rounded'
                    },
                },
                width: "20",
                xaxis: {
                    categories: ['File Responses', 'Text Responses']
                },
            }
        }
    }

    const getGridGraph = (response) => {
        let rowName = []
        let responseData = []
        let colName = []
        response.availableGridOptions.map((gridOption, index) => {
            let colCount = []

            gridOption.options.map((option, optionIndex) => {
                colCount.push(option.count)
                colName.push(option.text)

            })

            responseData.push(colCount)
            rowName.push(gridOption.text)
        })

        const transpose = (array, arrayLength) => {
            var newArray = [];
            for (var i = 0; i < array.length; i++) {
                newArray.push([]);
            };

            for (var i = 0; i < array.length; i++) {
                for (var j = 0; j < arrayLength; j++) {
                    newArray[j].push(array[i][j]);
                };

                if (arrayLength < array[0].length) {
                    for (let index = arrayLength; index < array[0].length; index++) {
                        newArray.push([])
                        newArray[index].push(array[i][index]);

                    }
                }
            };

            return newArray;
        }
        let transposedData = transpose(responseData, responseData.length)

        // console.log(transposedData)
        let graphSeries = transposedData.map((series, index) => {
            // console.log(series, colName[index])

            if (series[0] !== undefined) {
                return {
                    name: colName[index],
                    data: series
                }
            }

        })

        graphSeries = graphSeries.filter(Boolean)

        return {
            series: graphSeries,
            options: {
                chart: {
                    type: 'bar',
                    height: 350,
                    stacked: true,
                    toolbar: {
                        show: true
                    },
                    zoom: {
                        enabled: true
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                    },
                },
                xaxis: {
                    type: 'category',
                    categories: rowName,
                },
                legend: {
                    position: 'top',
                    offsetX: 40
                },
                fill: {
                    opacity: 1
                },
                stroke: {
                    show: true,
                    width: 25,
                    colors: ['transparent'],
                    dashArray: 10
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return + val + " Responses"
                        }
                    },

                }
            }
        }
    }
    const removeSpanTagsFromQuestion = (question) => {

        let questionFinal = question && question != undefined ? question.replace(/<span>|<\/span>/g, '') : ''
        return questionFinal
    }



    return (
        <div className="container-fluid">
            <h4 className="text-capitalize mt-3" style={{ fontWeight: '500', fontSize: '0.9rem' }}>
                {/* Activity Name */}
            </h4>
            <LoadingOverlay tag="div" active={isLoading}
                styles={{
                    overlay: (base) => ({
                        ...base,
                        background: "#fff",
                        opacity: 0.5,
                    }),
                }}
                spinner={
                    <Loader color="#6c757d" active type="ball-pulse" />
                }>



                <div style={{ paddingTop: '50px',paddingBottom: '100px' }}>
                    <div className='row' >
                        <div className={`col-12`} >
                        <h5 className="opacity-6 text-capitalize text-center">Total Responses: <b>{totalReplies}</b></h5>
                            <Card className="main-card">
                           
                                <CardHeader className="d-flex">
                                    <h5 className="opacity-6 text-capitalize">
                                        Demographics of survey
                                    </h5>
                                   
                                    {
                                        // width <= 350 ?
                                        //     <div className="btn-actions-pane-right align-self-center pt-0 custom_drop">
                                        //         <UncontrolledButtonDropdown>

                                        //             <DropdownToggle caret size="sm" className="btn-icon btn-icon-only" color="dark">
                                        //                 <div className="btn-icon-wrapper">
                                        //                     <FontAwesomeIcon icon={faBars} />
                                        //                 </div>
                                        //             </DropdownToggle>
                                        //             <DropdownMenu className="dropdown-menu-shadow dropdown-menu-hover-link" style={{ marginLeft: '-12.3rem' }}>
                                        //                 <DropdownItem onClick={() => newToggle("Country")}>
                                        //                     <span className="opacity-6">Country</span>
                                        //                 </DropdownItem>
                                        //                 <DropdownItem onClick={() => newToggle("City")}>
                                        //                     <span className="opacity-6">City</span>
                                        //                 </DropdownItem>
                                        //                 <DropdownItem onClick={() => newToggle("Gender")}>
                                        //                     <span className="opacity-6">Gender</span>
                                        //                 </DropdownItem>
                                        //                 <DropdownItem onClick={() => newToggle("Income Range")}>
                                        //                     <span className="opacity-6">Income Range</span>
                                        //                 </DropdownItem>
                                        //                 <DropdownItem onClick={() => newToggle("Signup")}>
                                        //                     <span className="opacity-6">Signup</span>
                                        //                 </DropdownItem>
                                        //             </DropdownMenu>
                                        //         </UncontrolledButtonDropdown>
                                        //     </div>
                                        //     :
                                            <div className="btn-actions-pane-right">
                                                <ButtonGroup size="sm">
                                                   
                                                    <Button color="dark"
                                                        className={
                                                            "btn-shadow " +
                                                            classnames({
                                                                active: newDemographicsActiveTab === "1",
                                                            })
                                                        }
                                                        onClick={() => {
                                                            newToggle("City");
                                                        }}>
                                                        City
                                                    </Button>
                                                    <Button color="dark"
                                                        className={
                                                            "btn-shadow " +
                                                            classnames({
                                                                active: newDemographicsActiveTab === "2",
                                                            })
                                                        }
                                                        onClick={() => {
                                                            newToggle("Gender");
                                                        }}>
                                                        Gender
                                                    </Button>
                                                    <Button color="dark"
                                                        className={
                                                            "btn-shadow " +
                                                            classnames({
                                                                active: newDemographicsActiveTab === "3",
                                                            })
                                                        }
                                                        onClick={() => {
                                                            newToggle("Income Range");
                                                        }}>
                                                        Income
                                                    </Button>
                                                    <Button color="dark"
                                                        className={
                                                            "btn-shadow " +
                                                            classnames({
                                                                active: newDemographicsActiveTab === "4",
                                                            })
                                                        }
                                                        onClick={() => {
                                                            newToggle("Age Range");
                                                        }}>
                                                        Age
                                                    </Button>
                                                   
                                                </ButtonGroup>
                                            </div>


                                    }


                                </CardHeader>
                                <CardBody>
                                    {newDemographicsChart()}
                                </CardBody>
                            </Card>
                        </div>

                    </div>
                </div>

                <div className="row">
                   
                    {
                        surveyResponse.length > 0 &&
                        surveyResponse.map((response, index) => {
                            return <>
                                {
                                    (response.questionType === 'radio' || response.questionType === 'checkbox' || response.questionType === 'spectrum') &&
                                    <div className="col-md-6 col-sm-12 pb-2" >
                                        <Card className="main-card" style={{ height: '100%' }}>
                                       
                                            <CardBody className="" >
                                                <p style={{ fontWeight: '500' }}>Q{index + 1}. {removeSpanTagsFromQuestion(response.questionText)}</p>
                                                <div className="text-center mb-3" >
                                                    <Chart options={getRadioCheckboxGraphs(response).options} series={getRadioCheckboxGraphs(response).series} type="donut" />
                                                </div>

                                            </CardBody>
                                        </Card>
                                    </div>
                                }

                                {/* {
                                    (response.questionType === 'image' || response.questionType === 'video') &&
                                    <div className="col-md-6 col-sm-12 pb-3 px-2">
                                        <Card className="main-card" style={{ height: '100%' }}>
                                            <CardBody className="">
                                                <p style={{ fontWeight: '500' }}>Q{index + 1}. {removeSpanTagsFromQuestion(response.questionText)}</p>
                                                <div className="radialBar">
                                                    <Chart options={getImageVideoGraph(response).options} series={getImageVideoGraph(response).series} type="radialBar" width="100%" />
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </div>
                                } */}

                                {

                                    response.questionType === 'long text' &&
                                    <div className="col-md-6 col-sm-12 pb-3 px-2">
                                        {/* {console.log('question id->', response.questionId)} */}
                                        <Card className="main-card" style={{ height: '100%' }}>
                                            <CardBody className="">
                                                <p style={{ fontWeight: '500' }}>Q{index + 1}. {removeSpanTagsFromQuestion(response.questionText)}</p>
                                                <div >

                                                    <GraphCartsWordCloud questionId={response.questionId} activityId={params.activityid} />
                                                </div>


                                            </CardBody>
                                        </Card>
                                    </div>
                                }

                                {/* {
                                    (response.questionType === 'image text' || response.questionType === 'video text') &&

                                    <div className="col-md-6 col-sm-12 pb-3 px-2">
                                        <Card className="main-card" style={{ height: '100%' }}>
                                            <CardBody className="">
                                                <p style={{ fontWeight: '500' }}>Q{index + 1}. {removeSpanTagsFromQuestion(response.questionText)}</p>
                                                <div className="radialBar">
                                                    <Chart options={getImageVideoTextGraph(response).options} series={getImageVideoTextGraph(response).series} type="bar" width="100%" />
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </div>
                                } */}
                                {
                                    response.questionType === 'grid' &&

                                    <div className={"col-sm-12 pb-3 px-2"}>

                                        <Card className="main-card" style={{ height: '100%' }}>
                                            <CardBody className="">
                                                <p style={{ fontWeight: '500' }}>Q{index + 1}. {removeSpanTagsFromQuestion(response.questionText)}</p>
                                                <div style={{ overflowX: 'scroll' }}>
                                                    <Chart options={getGridGraph(response).options} series={getGridGraph(response).series} type="bar" height="400" width={getGridGraph(response).series[0].data.length * 65} />
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </div>
                                }

                            </>
                        })
                    }
                </div>

            </LoadingOverlay >

        </div >
    )
}

export default Graphcharts
